import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import 'maplibre-gl/dist/maplibre-gl.css';
// Side-effect import: registers L.maplibreGL on the Leaflet namespace.
import '@maplibre/maplibre-gl-leaflet';
import { MAP_STYLE_URL, MAP_TILE_ATTRIBUTION } from './config';

// maplibre-gl-leaflet augments L at runtime but ships no types for it.
type MaplibreGLFactory = (options: { style: string }) => L.Layer;
const maplibreGL = (L as unknown as { maplibreGL: MaplibreGLFactory }).maplibreGL;

/**
 * Base map layer: renders a MapLibre vector style (OpenFreeMap by default) inside
 * our Leaflet maps via maplibre-gl-leaflet. Drop-in replacement for `<TileLayer>`
 * so we're off the public OSM raster server (whose policy bars commercial use)
 * while keeping every existing Leaflet overlay/marker/popup drawn on top.
 */
export function MapLibreTiles() {
  const map = useMap();
  useEffect(() => {
    const layer = maplibreGL({ style: MAP_STYLE_URL });
    layer.addTo(map);
    map.attributionControl?.addAttribution(MAP_TILE_ATTRIBUTION);
    return () => {
      map.removeLayer(layer);
      map.attributionControl?.removeAttribution(MAP_TILE_ATTRIBUTION);
    };
  }, [map]);
  return null;
}

export default MapLibreTiles;
